<template>
  <div>

    <!-- From company -->
    <base-fieldset>
      <label class="text-xs font-semibold">{{
          $t(`mygwf.components.Label.from_company`)
        }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-select
          v-model="fromCompany"
          class="width-limit"
          :options="companies"
          :optionType="{id: 'name', label: 'name'}"
          allowClear
          searchable
          size="sm"
        />
      </div>
    </base-fieldset>

    <!-- To company -->
    <base-fieldset>
      <label class="text-xs font-semibold">{{
          $t(`mygwf.components.Label.to_company`)
        }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-select
          v-model="toCompany"
          class="width-limit"
          :options="companies"
          :optionType="{id: 'name', label: 'name'}"
          allowClear
          searchable
          size="sm"
        />
      </div>
    </base-fieldset>

  </div>
</template>

<script>
import {
  BaseSelect,
  BaseIcon,
  BaseButton,
  BaseFieldset,
} from '@/components/base'
import _isEmpty from 'lodash-es/isEmpty'

export default {
  components: {
    BaseSelect,
    BaseIcon,
    BaseFieldset,
    BaseButton
  },

  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      fromCompany: this.$route.query.company_from_name || '',
      toCompany: this.$route.query.company_to_name || ''
    }
  },

  computed: {
    companies() { return this.$store.getters['companies/list']; }
  },

  watch: {
    $route(n, o) {
      if (_isEmpty(n.query)) {
        this.reset()
      }
    },
    fromCompany(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'company_from_name'})
    },
    toCompany(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'company_to_name'})
    },
  },

  methods: {

    submit() {
      let filters = {
        value: [this.fromCompany, this.toCompany],
        name: ['company_from_name', 'company_to_name']
      }
      this.$store.dispatch('app/filterProp', filters)
    },

    reset() {
      this.fromCompany = '';
      this.toCompany = '';
      this.$router.push({name: 'Transfers', query: {}})
    },
  },
}
</script>

<style></style>
